// import utility functions
import { formatCurrencyString } from '../util';

/**
 * Calculate amortized payments i.e. a monthly breakdown of payments and remaining balance
 * Formula for this came out of my head because the PHP version didn't make any sense
 *
 * @param {string} principal - amount of the loan
 * @param {number} rate - interest rate
 * @param {number} term - how long the loan is for
 * @return {Object[]} amortizedPayments - array of each month's payment with current balance, interest, and principal
 */
function calculateAmortizationSchedule(principal, rate, term, fixedPayment) {
  const initialBalance = parseFloat(principal);

  // easier to have a placeholder here at 0 than mess with modulo formula below
  const months = [
    'derp',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  /**
   * Function to calculate the current total at the current month
   * Called for every month in the term, this is where balance is updated to reflect the latest payment
   *
   * @param {number} balance - current balance of loan
   * @param {number} rate - interest rate, doesn't change
   * @param {number} payment - fixed payment, doesn't change
   */
  function getTotal(balance, rate, payment) {
    return {
      interest: balance * rate,
      principal: payment - balance * rate,
      currentBalance: balance - payment + balance * rate,
    };
  }

  // first entry
  let runningTotal = getTotal(initialBalance, rate, fixedPayment);

  // hold amortized payments
  let amortizedPayments = [];

  // skip zero so first entry corresponds with Year 1 not Year 0
  let i = 1;

  // for each month, get a new total
  while (i < term + 1) {
    const { interest, principal, currentBalance } = runningTotal;

    amortizedPayments[i] = {};
    amortizedPayments[i].year = Math.ceil(i / 12);
    amortizedPayments[i].month = months[i % 12 ? i % 12 : 12];

    // Sage 9 (Buble, specifically) doesn't seem to like the spread ... operator so use Object.assign() instead
    amortizedPayments[i] = Object.assign(
      {
        principal: formatCurrencyString(principal),
        interest: formatCurrencyString(interest),
        currentBalance: formatCurrencyString(currentBalance),
      },
      amortizedPayments[i]
    );

    // keep track of the total after the most recent payments have been subtracted
    runningTotal = getTotal(currentBalance, rate, fixedPayment);

    i++;
  }

  return amortizedPayments;
}

export default calculateAmortizationSchedule;



// WEBPACK FOOTER //
// ./scripts/svelte/calculators/mortgagePaymentCalculator/calculateAmortizationSchedule.js